import { useAppState } from "../context/StateContext";

export const useFormatCurrency = () => {
  const { currentUser } = useAppState();

  const code = currentUser?.currency?.code;

  const formatCurrencyString = (value?: number | string) => {
    if (!value) return "";

    return `${value} ${code}`;
  };

  return {
    formatCurrencyString,
  };
};
